import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { Clock, Users, Star } from "lucide-react";
import ExperienceStyle from "../../assets/stylesheets/experience/ExperienceCard.module.css";
import SkeletonCard from '../common/SkeletonCard';

export default function ExperienceCard({
  experience,
  index,
  onImageLoaded,
  onClick,
  loading
}) {
  const [imageLoaded, setImageLoaded] = useState(false);
  
  // Get cover image URL — handle multiple possible API shapes:
  //  { coverImage: { viewUrl } }  (mock / confirmed upload response)
  //  { coverImageUrl: "..." }     (BFF /public/cards + cover-image fetch)
  //  { image: { viewUrl } }       (alternate shape)
  const coverUrl =
    experience.coverImage?.viewUrl ||
    experience.coverImageUrl ||
    experience.cover_image?.viewUrl ||
    experience.image?.viewUrl ||
    experience.imageUrl ||
    "/assets-placeholder/no-image.png";

  // Image preload
  useEffect(() => {
    if (!coverUrl) return;
    
    const img = new Image();
    img.src = coverUrl;
    img.onload = () => {
      setImageLoaded(true);
      onImageLoaded?.(index);
    };
    img.onerror = () => {
      setImageLoaded(true);
      onImageLoaded?.(index);
    };
    
    return () => {
      img.onload = null;
      img.onerror = null;
    };
  }, [coverUrl, index, onImageLoaded]);

  // Loading state
  if (!imageLoaded) {
    return <SkeletonCard />;
  }

  // After loading
  return (
    <div className={ExperienceStyle["experience-card"]} onClick={onClick}>
      <div className={ExperienceStyle["experience-card-image-container"]}>
        {experience.badge && (
          <div className={ExperienceStyle["card-badge"]}>
            {experience.badge}
          </div>
        )}
        <img
          src={coverUrl}
          alt={experience.title}
          className={ExperienceStyle["experience-card-image"]}
        />
      </div>
      
      <div className={ExperienceStyle["experience-card-content"]}>
        <h3 className={ExperienceStyle["experience-card-title"]}>
          {experience.title}
        </h3>
        
        <p className={ExperienceStyle["experience-card-farm"]}>
          {experience.farmName}
        </p>
{/*         
        <div className={ExperienceStyle["experience-card-meta"]}>
          <div className={ExperienceStyle["meta-item"]}>
            <Clock size={14} />
            <span>{experience.duration}</span>
          </div>
          <div className={ExperienceStyle["meta-item"]}>
            <Users size={14} />
            <span>Up to {experience.groupSize}</span>
          </div>
        </div> */}
        
        <div className={ExperienceStyle["experience-card-footer"]}>
          <div className={ExperienceStyle["rating"]}>
            <Star size={14} fill="currentColor" />
            <span>{experience.rating}</span>
            <span className={ExperienceStyle["review-count"]}>
              ({experience.reviewCount})
            </span>
          </div>
          <div className={ExperienceStyle["price"]}>
            <span className={ExperienceStyle["price-from"]}>From</span>
            <span className={ExperienceStyle["price-amount"]}>${experience.price}</span>
            <span className={ExperienceStyle["price-per"]}>/ person</span>
          </div>
        </div>
      </div>
    </div>
  );
}

ExperienceCard.propTypes = {
  experience: PropTypes.shape({
    id: PropTypes.number.isRequired,
    title: PropTypes.string.isRequired,
    farmName: PropTypes.string.isRequired,
    duration: PropTypes.string.isRequired,
    groupSize: PropTypes.number.isRequired,
    rating: PropTypes.number.isRequired,
    reviewCount: PropTypes.number.isRequired,
    price: PropTypes.number.isRequired,
    badge: PropTypes.string,
    coverImage: PropTypes.shape({
      viewUrl: PropTypes.string,
    }),
  }).isRequired,
  index: PropTypes.number,
  onImageLoaded: PropTypes.func,
  onClick: PropTypes.func,
  loading: PropTypes.bool,
};
